import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { AVAILABLE_ROOMS_MANY_TEXT, type AvailableRooms } from '@this/domain/hotel/available_rooms';

const infoIconStyle = { fontSize: '14px', verticalAlign: 'middle', marginLeft: '2px', cursor: 'help' } as const;

export const InfoTooltipIcon = ({ title }: { title: string }) => (
  <Tooltip title={title} placement="right">
    <InfoOutlinedIcon style={infoIconStyle} />
  </Tooltip>
);

export const AvailableRoomsText = ({ availableRooms }: { availableRooms: AvailableRooms | undefined }) => {
  if (typeof availableRooms === 'number') {
    return <span data-wovn-ignore>{`残${availableRooms}室`}</span>;
  }
  if (availableRooms === 'many') {
    return <span data-wovn-ignore>{AVAILABLE_ROOMS_MANY_TEXT}</span>;
  }
  if (availableRooms === true) {
    return (
      <span data-wovn-ignore>
        ○
        <InfoTooltipIcon title="提携先の都合で正確な残室数は取得できません" />
      </span>
    );
  }
  return null;
};
